
import React from 'react';
import { Bell, Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { useSidebar } from '@/components/ui/sidebar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TopbarLanguageDropdown } from '@/components/common/TopbarLanguageDropdown';
import { cn } from '@/lib/utils';

export const MobileAdminTopbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { toggleSidebar } = useSidebar();
  
  return (
    <header className="h-14 flex items-center justify-between px-3 border-b border-border bg-background safe-area-top pt-safe">
      <div className="flex items-center space-x-3">
        <Button variant="ghost" size="icon" onClick={toggleSidebar} aria-label="Toggle menu">
          <Menu size={20} />
        </Button>
        <h1 className="text-lg font-bold truncate">Admin</h1>
      </div>
      
      <div className="flex items-center space-x-1">
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Bell size={18} />
        </Button>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="relative h-8 w-8 rounded-full p-0">
              <Avatar className="h-8 w-8">
                <AvatarFallback className={cn("bg-primary/20 text-primary-foreground text-sm")}>
                  {user?.user_metadata?.name?.split(' ')
                    .map(n => n[0])
                    .join('')
                    .toUpperCase() || 'A'}
                </AvatarFallback>
              </Avatar>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56" align="end" forceMount>
            <DropdownMenuLabel className="font-normal">
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium leading-none">{user?.user_metadata?.name || 'Admin'}</p>
                <p className="text-xs leading-none text-muted-foreground">{user?.email}</p>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <TopbarLanguageDropdown buttonVariant="menuItem" />
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/')}>
              Back to Dashboard
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/settings')}>
              Account Settings
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};
